export default __webpack_public_path__ + "static/logo-main-3c1b6c3a6a8f5c08408010a6d80e03c6.jpg";